import { useSearch } from "wouter/use-location";

export function useSearchParams() {
  return Object.fromEntries(new URLSearchParams(useSearch()));
}
